/* @flow */
// typecheck: ignore file
import React from 'react';
import { Container } from 'flux/utils';
import DeviceActions from 'actions/DeviceActions';
import Devices from 'collections/Devices';
import DeviceStore from 'stores/DeviceStore';
import waitForPromises from 'lib/waitForPromises.jsx';
import CurrentUser from 'auth/CurrentUser';
import NotificationSettingsView from 'settings/components/NotificationSettingsView.jsx';

type State = {
  devices: Devices,
  showSmsDevices: boolean,
  showNotificationPreferences: boolean,
};

class NotificationSettingsContainer extends React.Component {
  state: State;

  static getStores() {
    return [
      DeviceStore,
    ];
  }

  static routePrefetch = [
    () => {
      if (!DeviceStore.isLoaded()) {
        DeviceActions.localDeleteAll()
          .then(DeviceActions.loadDevices)
          .catch(e => console.error('NotificationSettingsContainer failed to delete all devices', e));
      }
    },
  ]

  static calculateState() {
    return {
      devices: DeviceStore.getDevices(),
      showSmsDevices: CurrentUser.getUser().hasSmsSupported(),
      showNotificationPreferences: CurrentUser.getUser().canCreateGroups(),
    };
  }

  render() {
    return (
      <NotificationSettingsView
        devices={this.state.devices}
        showSmsDevices={this.state.showSmsDevices}
        showNotificationPreferences={this.state.showNotificationPreferences}
      />
    );
  }
}

export default waitForPromises(Container.create(NotificationSettingsContainer));



// WEBPACK FOOTER //
// ./src/settings/containers/NotificationSettingsContainer.jsx